import { Component, Input, OnInit, TemplateRef, Output, EventEmitter } from '@angular/core';
import { MappingSortingModel } from '../../../models/mappingsorting.model';

@Component({
  selector: 'hhsg-filter',
  templateUrl: './mapping-filter.component.html',
  styleUrls: ['./mapping-filter.component.scss']
})
export class MappingFilterComponent {
  @Input() sortOptions: MappingSortingModel[] = [];
  @Input() legendTemplate: TemplateRef<HTMLElement>;
  @Input() hasLegends: boolean;
  @Output() sortTypeChangeEvent = new EventEmitter<any>();
  @Output() selectedFilterEvent = new EventEmitter<any>();
  @Output() setSelectedFilterEvent = new EventEmitter<any>();
  @Output() sortUpDownChangeEvent = new EventEmitter<any>();
  @Output() searchChangeEvent = new EventEmitter<any>();
  isAsc: Boolean = true;
  constructor() { }


  onSortTypesDropDownChanged(event: any) {
    this.sortTypeChangeEvent.emit(event);
  }

  setSelectedFilter(event: any) {
    this.setSelectedFilterEvent.emit(event);
  }

  selectedFilter(event: any) {
    this.selectedFilterEvent.emit(event);
  }

  sortUpDownChange(){
    this.isAsc = !this.isAsc;
    this.sortUpDownChangeEvent.emit();
  }
  onSearchChange(inputValue: string){
    this.searchChangeEvent.emit(inputValue);
  }

}

